import { ApiService, createGetService } from '@ligo/shared/utils';
import { RESOURCES } from '../resources';
import { Subscription, SubscriptionType } from '@ligo/shared/auth';
import Vue from 'vue';
import VueRouter from 'vue-router';

const STORAGE_KEY = 'selected-subscription-id';

export const SubscriptionService = {
  ...createGetService<SubscriptionType>(RESOURCES.SUBSCRIPTION_TYPES),

  changeSubscription(subscriptionTypeId: number) {
    return ApiService.post<{ subscription_type_id: number }, Subscription>(
      RESOURCES.SUBSCRIPTIONS,
      {
        subscription_type_id: subscriptionTypeId
      },
      false
    );
  },
  cancelSubscription() {
    return ApiService.delete(`${RESOURCES.SUBSCRIPTIONS}/cancel`);
  },
  async createAndRedirect(subscriptionType: string) {
    const response = await this.changeSubscription(subscriptionType);
    const payment = response.data.payments?.[0];
    if (payment) {
      const router = Vue['Router'] as VueRouter;
      router.push({
        name: 'Account',
        query: {
          paymentUuid: payment.uuid
        }
      });
      return true;
    }
  },
  async checkAndCreateFromStorage() {
    const subscriptionTypeId = localStorage.getItem(STORAGE_KEY);
    if (subscriptionTypeId) {
      const redirected = await this.createAndRedirect(subscriptionTypeId);
      this.clearSelection();
      return redirected;
    }
  },
  clearSelection() {
    localStorage.removeItem(STORAGE_KEY);
  },
  saveSelection(subscriptionTypeId: string) {
    localStorage.setItem(STORAGE_KEY, subscriptionTypeId);
  }
};
